// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".noData[data-v-bf708e56]{height:100%;text-align:center;position:relative}.noData .noData-pic[data-v-bf708e56]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.noData .noData-pic img[data-v-bf708e56]{margin-bottom:10px}.noData p[data-v-bf708e56]{margin:0;padding:0;line-height:100%}", ""]);
// Exports
module.exports = exports;
